angular.module('tgaAdmin')
  .service('playersService', ['$http', 'envService', 'localStorageService', 'domainService',
    function ($http, envService, localStorageService, domainService) {
      const serverAddress = envService.read('serverAddress');

      function getPlayers() {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/player`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function registerPlayer(player) {
        return $http({
          method: 'POST',
          url: `${serverAddress}player/register`,
          data: {
            username: player.email,
            email: player.email,
            first_name: player.first_name,
            last_name: player.last_name,
            initials: player.initials,
            display_name: player.display_name,
            send_email: false,
            add_to_domain: true,
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getPlayers,
        registerPlayer,
      });
    }]);
